import { css, SerializedStyles } from '@emotion/react';
import tw from 'twin.macro';

export interface CTAPluginTheme {
  button?: SerializedStyles;
  wrapper?: SerializedStyles;
  input?: SerializedStyles;
  inputInvalid?: SerializedStyles;
}

export const defaultTheme = {
  button: css`
    margin: 0 auto;
    color: inherit;
    background: inherit;
    font-family: inherit;
    border-radius: inherit;
    text-decoration: none;
    flex-direction: row;
    cursor: pointer;
    white-space: nowrap;
    display: flex;
    display: flex;
    padding: 0.25rem 0.5rem;
    border-width: 0px;
    outline: none;
    font-size: 1rem;
    font-weight: 500;
    box-sizing: border-box;
    line-height: 1.5;
    justify-content: center;
    align-items: center;
    appearance: none;
    outline: 0px;
    position: relative;
    ${tw`w-full md:w-auto whitespace-nowrap`}
    &:hover {
      box-shadow: 0 0 0 3px #accef7;
    }
    &.is-publish {
      padding: 0.5em 2em;
      cursor: pointer !important;
      pointer-events: all;
      &:hover {
        border: none !important;
        box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%), 0 4px 6px -2px rgb(0 0 0 / 10%);
        transition: transform 0.2s, box-shadow 0.2s;
        transform: translateY(-1px);
      }
      &:active {
        ${tw`shadow-none`}
      }
    }
    textarea {
      font-family: inherit;
      font-size: inherit;
      font-weight: 500;
      height: 2.015rem;
      line-height: 1.925rem;
      padding: 0 1rem;
      background: inherit;
      color: inherit;
      text-align: center;
      border: none;
      outline: none;
      overflow: hidden;
      white-space: nowrap;
      resize: none;
      width: auto;
      &:disabled {
        &:hover {
          cursor: pointer;
        }
      }
    }
  `,
  wrapper: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 1rem 1.25rem;
    width: 360px;
    .field-group {
      display: flex;
      align-items: center !important;
      margin-bottom: 0.75rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
    button {
      color: #ddd;
      cursor: pointer;
      font-size: 1rem;
      white-space: nowrap;
      &:hover {
        color: #fff;
      }
    }
    .button-options {
      width: 100%;
      justify-content: flex-start;
      .radio {
        &:before {
          top: 0;
          left: 0;
        }
      }
      .checked {
        .setting.toggle {
          color: #fff;
        }
      }
    }
    .field-text {
      width: 4rem;
      font-size: 1rem !important;
    }
    label {
      color: #ddd;
      .toggle {
        color: #ddd;
      }
      input:checked + .radio {
        &:after {
          background: #888;
        }
      }
      &:last-child {
        margin: 0 !important;
        .toggle {
          margin-right: 0 !important;
        }
      }
    }
  `,
  input: css`
    width: 100%;
    appearance: none;
    outline: none;
    height: auto;
    max-height: 30px;
    text-align: center;
    color: #ddd;
    font-size: 1rem !important;
    line-height: 1.25;
    background: inherit;
    transition: background 100ms ease 0s;
    border-width: 2px;
    border-style: dashed;
    border-color: #ddd;
    border-radius: 6px;
    padding: 0.5rem 1rem !important;

    &.url-input {
      text-align: left;
    }
    &::placeholder {
      color: #999999;
    }
    &:focus {
      border-style: solid;
      box-shadow: none;
    }
    &::-webkit-scrollbar {
      display: none;
    }
    &::-moz-selection {
      color: #fff;
      background-color: #3297fd;
    }
    &::selection {
      color: #fff;
      background-color: #3297fd;
    }
  `,
  inputInvalid: css`
    border-color: #e65757 !important;
    &::placeholder {
      color: #e65757;
    }
  `,
};
